export interface JunctionExitRoad {
  locationId?: string;
  name: string;
}

/** Parse OSM-style semicolon-separated exit_to or stored linkage metadata. */
export function parseJunctionExitRoads(
  exitTo?: string | null,
  exitToRoads?: Array<{ location_id?: string; name?: string }> | null,
): JunctionExitRoad[] {
  if (Array.isArray(exitToRoads) && exitToRoads.length > 0) {
    return exitToRoads
      .map((road) => ({
        locationId: road.location_id?.trim() || undefined,
        name: road.name?.trim() ?? '',
      }))
      .filter((road) => road.name.length > 0);
  }
  if (!exitTo?.trim()) return [];
  return exitTo
    .split(';')
    .map((part) => part.trim())
    .filter(Boolean)
    .map((name) => ({ name }));
}

export function formatJunctionExitTo(roads: JunctionExitRoad[]): string {
  return roads.map((road) => road.name.trim()).filter(Boolean).join('; ');
}
